<template>
  <div class="audio-container">
    <v-row>
      <v-col
        cols="12"
        sm="5"
        md="5"
        lg="4"
        xl="4"
        class="pa-md-0 pa-sm-0 py-0"
        :class="playerOrder"
      >
        <div class="playing">
          <div class="card-content" v-if="selectedAudio">
            <div v-if="!isMobile" class="player-image-container">
              <div class="now-playing">
                Now playing: {{ selectedAudio.Name[0] }}
              </div>

              <v-img src="/img/audioImage.jpg" aspect-ratio="2"></v-img>
            </div>
            <template>
              <div>
                <v-app-bar color="#1c1c1c" dark dense class="optionToolbar">
                  <audio-player
                    ref="AudioPlayer"
                    :file="selectedAudio.Filepath[0]"
                    :audioTitle="selectedAudio.Name[0]"
                    :bookTitle="bookTitle"
                    :chapter="chapter"
                    :section="section"
                    v-on:pause="updateActiveAudio"
                    autoPlay
                  ></audio-player>
                  <v-menu left bottom v-if="isMobile">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        @click="isTranscriptShown = !isTranscriptShown;"
                      >
                        <v-list-item-title>{{ switchLabel }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-app-bar>
              </div>
            </template>
            <v-switch
              color="black"
              flat
              inset
              v-if="hasTranscript && !isMobile"
              v-model="isTranscriptShown"
              :label="switchLabel"
            ></v-switch>
          </div>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="7"
        md="7"
        lg="8"
        xl="8"
        class="order-2 sidebar-container"
      >
          <div class="transcript-container" v-if="isTranscriptShown">
            <div class="transcript-content">
              <v-toolbar flat>
                <v-spacer>Transcript</v-spacer>
                <v-btn icon @click="hideTranscript()" class="close-btn">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <div class="transcript-label" v-html="transcriptContent"></div>
            </div>
          </div>
          <div class="playlist-container">
            <v-card>
              <v-list flat>
                <v-list-item-group>
                  <v-list-item
                    v-for="(media, index) in this.sectionContent.Media"
                    :key="index"
                    @click.stop="changeAudio(media, index)"
                    :class="{ active: index === activeItem }"
                  >
                    <MediaItem>
                      <template #icon v-if="index === activeItem"
                        >mdi-pause-circle</template
                      >
                      <template #icon v-else
                        >mdi-arrow-right-drop-circle</template
                      >
                      <template #name>{{ media.Name[0] }}</template>
                      <template #duration>{{ media.Duration[0] }}</template>
                    </MediaItem>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MediaItem from '@/components/media/MediaItem'
import AudioPlayer from '@/components/media/AudioPlayer'
export default {
  name: 'MediaAudio',
  components: {
    MediaItem,
    AudioPlayer
  },
  props: ['chapter', 'section', 'bookTitle', 'sectionContent'],
  beforeDestroy () {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize, { passive: true })
  },
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  updated () {
    if (this.selectedAudio.Caption && this.selectedAudio.Caption[0] !== '') {
      this.getTranscriptContent(this.selectedAudio.Caption[0])
    } else {
      this.hasTranscript = false
    }
  },
  data () {
    return {
      mediaElement: null,
      paused: null,
      selectedAudio: null,
      selectedIndex: null,
      currentMedia: null,
      nowPlaying: null,
      hasTranscript: false,
      isTranscriptShown: false,
      transcriptContent: null,
      activeItem: null,
      lastActiveItem: null,
      isMobile: false
    }
  },
  methods: {
    updateActiveAudio (mediaElement) {
      this.paused = mediaElement.paused
      if (this.paused) {
        this.activeItem = false
      } else {
        this.activeItem = this.lastActiveItem
      }
    },
    changeAudio (media, index) {
      this.mediaElement = this.$el.querySelectorAll('audio')[0]
      if (this.selectedAudio !== media) {
        this.selectedAudio = media
        this.selectedIndex = index
        this.activeItem = index
        this.lastActiveItem = index
        this.isTranscriptShown = false
      } else {
        this.$refs.AudioPlayer.pause()
        if (this.mediaElement.paused) {
          this.activeItem = false
        } else {
          this.activeItem = index
        }
      }
    },
    getTranscriptContent (filePath) {
      axios.get(filePath).then(response => {
        if (response.data) {
          this.hasTranscript = true
          this.transcriptContent = response.data
        }
      }).catch(error => {
        this.hasTranscript = false
      })
    },
    hideTranscript () {
      this.isTranscriptShown = false
    },
    onResize () {
      this.isMobile = window.innerWidth < 600
    }
  },
  computed: {
    switchLabel () {
      return this.isTranscriptShown ? 'Hide transcript' : 'Show transcript'
    },
    playerOrder () {
      return this.isMobile ? 'order-4' : 'order-1'
    }
  }
}
</script>

<style lang="scss">
.audio-container {
  min-height: auto;
  margin: auto;
  .playing {
    @media only screen and (min-width: 600px) {
      min-width: 240px;
    }
    width: 100%;
    min-width: 240px;
    padding-top: 32px;
    padding-bottom: 10px;
    .card-content {
      margin: auto;
      display: flex;
      flex-direction: column;
      audio {
        max-height: 300px;
        background-color: #f1f3f4;
        @media only screen and (min-width: 600px) {
          width: 100%;
        }
        width: 100%;
        background-color: #232323;
      }
      .v-input--selection-controls__input {
        height: 16px;
        width: 30px;
        transform: scale(0.6);
      }
      .v-label {
        font-size: 15px;
        color: #323232;
      }
      .player-image-container {
        position: relative;
        .now-playing {
          position: absolute;
          width: 100%;
          color: #fff;
          z-index: 10;
          background-color: rgba(0, 0, 0, 0.5);
          height: 48px;
          padding: 16px;
          font-size: 11px;
        }
      }
    }
  }
  .sidebar-container {
    display: flex;
    padding-left: 20px;
    @media screen and (max-width: 1000px) {
      flex-direction: column;
    }
    .transcript-container {
      width: 100%;
      min-width: 250px;
      padding: 0px 10px;
      .transcript-content {
        padding: 5px;
        border: 1px solid #e0e0e0;
        box-sizing: border-box;
        font-size: 15px;
        .v-toolbar {
          height: auto !important;
          .v-toolbar__content {
            padding: 0px;
            height: auto !important;
            .spacer {
              font-weight: 600;
            }
          }
        }
      }
      .transcript-label {
        max-height: 300px;
        overflow-y: auto;
      }
    }
    .playlist-container {
      width: 100%;
      min-width: 220px;
    }
  }

  .v-card {
    margin: 0px;
    height: 100%;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: none !important;
    clear: both;
    .v-list {
      background-color: none !important;
      .v-list-item-group {
        border-top: 1px solid #dadada;
        .v-list-item {
          padding: 0px;
          margin: 0px;
          border-bottom: 1px solid #dadada;
          height: 48px;
          background-color: none !important;
          .v-icon {
            transform: scale(1.2);
          }
        }
      }
      .v-list-item--active {
        background-color: #f2f2f2;
        color: #004855;
      }
    }
  }
  .theme--light.v-sheet {
    background-color: transparent;
  }
  .theme--light.v-card {
    background-color: transparent;
  }
}

</style>
